import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLocationDot} from "@fortawesome/sharp-solid-svg-icons/faLocationDot";
import clsMerge from "@/app/util/clsMerge";
import {locationLabelStyles} from "@/app/_components/layout/CampusLabel";

/**
 * Loading placeholder for campus name and location pin
 */
const LoadingLocationLabel: React.FC<{}> = () => (
	<div
		className={clsMerge(locationLabelStyles, "animate-pulse opacity-80")}
		aria-label="Loading Campus Location Name..."
	>
		<FontAwesomeIcon
			className="text-gray-400 opacity-80"
			icon={faLocationDot}
		/>
		<div className="h-5 w-24 rounded bg-gray-400 opacity-80"></div>
	</div>
);

export default LoadingLocationLabel;
